import $ from 'jquery';


$(document).on('click', '.videos__item.js:not(.videos__item--playlist), .button--show-video', function(){

    var $this = $(this);
    var videoSource = $this.data('video-source') ? $this.data('video-source') : 'youtube';

    if (videoSource == 'vimeo') {
        var videoLink = $this.data('vimeo-link');
        var iframeEmbed = 'https://player.vimeo.com/video/' + videoLink + '?autoplay=1&loop=1&autopause=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen';
    } else {
        var videoLink = $this.data('video-link');
        var iframeEmbed = 'https://www.youtube.com/embed/' + videoLink + '?autoplay=1&controls=1&playlist=' + videoLink + '&rel=0&modestbranding=1&showinfo=0&autohide=1';
    }

    
    
    $('.video--youtube').attr('src', iframeEmbed);
    $('.dimmer--media.js').dimmer({
        closable: false
    }).dimmer('show');

    $('.videos__frame iframe').each(function(){
        
        var thisVideoCurrent = $(this).attr('data-video');
        var iframeEmbed_current = 'https://www.youtube.com/embed/' + thisVideoCurrent + '?autoplay=0&controls=1&playlist=' + thisVideoCurrent + '&rel=0&modestbranding=1&showinfo=0&autohide=1?enablejsapi=1';

        $(this).attr('src', iframeEmbed_current);

        player.unMute(); // Unmute the video
        player.playVideo(); // Play the video with sound
    });
});

$(document).on('click', '.show-video-youtube.js, .show-video-vimeo.js', function(){

    var $this = $(this);
    var videoSource = $this.data('video-source') ? $this.data('video-source') : 'youtube';
    var iframeVideo = $(this).parents('.image').find('.image__iframe-wrap iframe');

    if (videoSource == 'vimeo') {
        var videoLink = $this.data('vimeo-link');
        var iframeEmbed = 'https://player.vimeo.com/video/' + videoLink + '?autoplay=1&loop=1&autopause=0&background=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen';
        
        $(this).parents('.image').find('.image__iframe-wrap').show();
        iframeVideo.attr('src', iframeEmbed);
    
        if (iframeVideo.length) {
            const player = new Vimeo.Player(iframeVideo[0]);
    
            
            player.setVolume(0); // Mute the video
            player.play(); // Play the video
        }
    
    } else {



        let players = [];

        function onYouTubeIframeAPIReady() {
            // Initialize a player for each iframe with the "youtube-video" class
            $('.youtube-video').each(function(index) {
                players[index] = new YT.Player(this, {
                    events: {
                        'onReady': onPlayerReady
                    }
                });
            });
        }

        var videoLink = $this.data('video-link');
        var iframeEmbed = 'https://www.youtube.com/embed/' + videoLink + '?autoplay=1&mute=1&controls=1&playlist=' + videoLink + '&rel=0&modestbranding=1&showinfo=0&autohide=1';

        $(this).parents('.image').find('.image__iframe-wrap').show();

        iframeVideo.attr('src', iframeEmbed);
    }

    
    
   

    // $('.videos__frame iframe').each(function(){
        
    //     var thisVideoCurrent = $(this).attr('data-video');
    //     var iframeEmbed_current = 'https://www.youtube.com/embed/' + thisVideoCurrent + '?autoplay=0&controls=1&playlist=' + thisVideoCurrent + '&rel=0&modestbranding=1&showinfo=0&autohide=1?enablejsapi=1';

    //     $(this).attr('src', iframeEmbed_current);
    // });
});


$(document).on('click', '.dimmer__close', function() {
    var $this = $(this);
    $this.parents('.ui.dimmer').dimmer('hide').dimmer({
        onHide: function() {
        }
    });


    $('.video--youtube').removeAttr('src');
});
  
  